"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _InfoModalModule = _interopRequireDefault(require("../../styles/components/Info/InfoModal.module.css"));
var _actions = require("../../redux/actions");
var _selectors = require("../../redux/selectors");
var _EnergyValve = _interopRequireDefault(require("../../images/EnergyValve.png"));
var _constants = require("../../utils/constants");
var _reducers = require("../../redux/reducers");
var _sagas = _interopRequireDefault(require("../../redux/sagas"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/** @todo remove open flag from redux */
/** @todo remove important after remove global styles */
/** change card component */
/** remove less styles */
const InfoModalContent = () => {
  const {
    open = false
  } = (0, _reactRedux.useSelector)(_selectors.getInfoModal) || {};
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    source: sourceUrl
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const infoSourceUrl = "".concat(sourceUrl, "/images/info");
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUIInfo);
  const closeAlarmModal = (0, _react.useCallback)(() => {
    dispatch((0, _actions.setInfoModal)({
      open: false
    }));
  }, [dispatch]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_material.Modal, {
    id: "InfoModal",
    "aria-labelledby": "transition-modal-title",
    "aria-describedby": "transition-modal-description",
    open: open,
    onClose: closeAlarmModal,
    closeAfterTransition: true,
    className: _InfoModalModule.default.box_modal
  }, /*#__PURE__*/_react.default.createElement(_material.Fade, {
    in: open,
    timeout: 500
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _InfoModalModule.default.page
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-center w-100 h-100"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _InfoModalModule.default.image
  }, /*#__PURE__*/_react.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    effect: "blur",
    src: _EnergyValve.default
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _InfoModalModule.default.line
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _InfoModalModule.default.info
  }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Card, {
    className: "".concat(_InfoModalModule.default.card),
    theme: {
      text_align: 'center',
      padding: '29px 12px 26px'
    },
    title: tI['ENERGY_VALVE_TITLE'],
    showCloseBtn: true,
    onClose: closeAlarmModal
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _objectSpread({
      overflowY: 'auto',
      scrollbarGutter: 'stable',
      width: 'calc(100% + 32px)'
    }, _constants.smallScrollbar),
    className: _InfoModalModule.default.content
  }, /*#__PURE__*/_react.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage
  // src={energyValvePhoto}
  , {
    src: "".concat(infoSourceUrl, "/EnergyValve/EnergyValveInfoCard_v1.jpg"),
    style: {
      width: '100%',
      height: '275.5px',
      userSelect: 'none',
      pointerEvents: 'none'
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h5",
    sx: {
      my: 3,
      fontWeight: 'bold',
      lineHeight: '120% !important',
      color: _constants.colors['main-color-cl-01']
    }
  }, tI['ENERGY_VALVE_HEADER'] || ''), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "span",
    variant: "body1",
    sx: {
      color: _constants.colors['main-color-cl-01'],
      letterSpacing: '0.15px'
    }
  }, tI['ENERGY_VALVE_TEXT'] || ''))))))))), [open, closeAlarmModal, tI]);
};
const InfoModal = _ref => {
  let {} = _ref;
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      reducers: _reducers.reducers
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(InfoModalContent, null);
};
var _default = exports.default = InfoModal;